module.exports = __webpack_public_path__ + "static/media/police_complaint.6bfa2796.svg";